import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import i18n from "./i18n";

Vue.config.productionTip = false;

import "@/css/all.scss";

import Markdown from "./markdown";
Vue.use(Markdown);

import Storage from "./storage";
Vue.use(Storage);

import Auth from "./auth";
Vue.use(Auth);

import Servers from "@/code/servers";
Vue.use(Servers);

import Layout from "./layout";
Vue.use(Layout);

new Vue({
  router,
  i18n,
  render: (h) => h(App),
}).$mount("#app");
